export const DatabaseContext = {
  OFFICIAL: "official",
  WORKSPACE: "workspace",
};
